import type { VehicleOrder2Schemas } from './index'

export function getModelSnapshots({
  existingModelSnapshots,
  requiredModelNumbers,
  allModelInfo
}: {
  existingModelSnapshots: VehicleOrder2Schemas.vehicleOrderModelSnapshot[]
  requiredModelNumbers: string[]
  allModelInfo: VehicleOrder2Schemas.vehicleOrderModelSnapshot[]
}) {
  const missingModels = requiredModelNumbers.filter((m) => !existingModelSnapshots.some((e) => e.modelNumber === m))
  const extraModelNumbers = existingModelSnapshots.map((e) => e.modelNumber).filter((e) => !requiredModelNumbers.includes(e))
  const newModelInfo = missingModels.map((modelNumber) => {
    const match = allModelInfo.find((m) => m.modelNumber === modelNumber)
    if (match) {
      return {
        modelNumber: match.modelNumber,
        msrp: match.msrp,
        freightCost: match.freightCost,
        year1ResidualValuePercentage: match.year1ResidualValuePercentage,
        year2ResidualValuePercentage: match.year2ResidualValuePercentage,
        year3ResidualValuePercentage: match.year3ResidualValuePercentage
      }
    } else {
      throw new Error(`Missing model info for ${modelNumber}`)
    }
  })
  return [...existingModelSnapshots, ...newModelInfo].filter((s) => !extraModelNumbers.includes(s.modelNumber))
}
